window.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('#main-content');

    const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                if (mutation.target.classList.contains('sc-fc5bf192-6')) {
                    const el = document.querySelector('.sc-816bd5e4-0')

                    if (el) {
                        const title = el.querySelector('h2');
                         
                        if (title) {
                            title.innerText = "Build a Box";
                            observer.disconnect();
                        }
                    }
                }
            }
          }
    });

    observer.observe(body, { childList: true, subtree: true });
})